import React, { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section id="faq" className="bg-ink-2" data-id="element-35" data-mp="1gd7gc7wyl95h">
      <div className="mx-auto grid max-w-5xl gap-10 px-6 py-16 sm:py-24 lg:grid-cols-[5fr_7fr] lg:gap-16" data-id="element-36" data-mp="1geiki8ubgix4">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-37" data-mp="2dyd9hc8c4czl">
          <p className="mb-3 font-semibold text-accent" data-id="element-38" data-mp="292eh7djvyatw">Preguntas frecuentes</p>
          <h2 className="font-serif text-[30px] font-bold leading-tight sm:text-5xl" data-id="element-39" data-mp="241qomng0dlxk">Lo que más me preguntan</h2>
        </div>

        <div className="border-t border-line" data-id="element-40" data-mp="1z2dudhmt5cky">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="border-b border-line" data-id="element-41" data-mp="no098kjfvb8m" data-mpi={i}>
                <h3 data-id="element-42" data-mp="nmgu4x9ir68f">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-6 py-6 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-43" data-mp="nq4k5mfr9aie">
                    <span className="font-serif text-[17px] font-bold leading-snug" data-id="element-44" data-mp="kko4hjayenw1">{f.q}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-accent transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-45" data-mp="6pdf2lfhauz2" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-46" data-mp="1sv8rh4i2okm">
                  {isOpen && <motion.div id={`faq-${i}`} role="region" initial={reduce ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={reduce ? {
                opacity: 0
              } : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-47" data-mp="3jz9n3h6ol0jj">
                      <p className="pb-6 text-[15px] leading-[1.8] text-soft" data-id="element-48" data-mp="1fsgjfkb4kl9h">
                        {f.a}
                        {f.link && <>
                            {" "}
                            <a href={f.link.href} target="_blank" rel="noopener noreferrer" className="text-accent underline underline-offset-4 hover:text-accent-hover" data-id="element-49" data-mp="28hnl2s5vlqyy">
                              {f.link.label}
                            </a>
                            .
                          </>}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}